import numberToWords from "@iyansr/angka-terbilang";
import dayjs from "dayjs";
import React, { Component } from "react";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import withFormGroup from "../../../../../modules/commons/withFormGroup";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import SimpleDate from "../../../../../modules/SimpleDate";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleInput from "../../../../../modules/SimpleInput";
import SimpleTextArea from "../../../../../modules/simpleTextArea";
import Api from "../../../../../Services/Api";
import { GenericSequenceType, HttpStatus, Status } from "../../../../common/Constants";
import { flattenFormGroupObject, getValueFromDDL, mapToObjectDDL } from "../../../../common/mapper";
import { downloadPdf, printPDF } from "../../common/downloadUtils";
import SimpleCheckBox from "../../../../../modules/SimpleCheckBox";
import {
    contructQueryParam,
    fetchDataAsync,
    FormatCurrencyWithoutSymbol,
    isNotNilAndEmpty
} from "../../../../../Services/Utils";
import * as R from "ramda";
import DocumentReference from "../../common/documentReference";
import M from "moment";
import { connect } from "react-redux";
import SimpleAlert from "../../../../../modules/popup/SimpleAlert";
import FlexView from "react-flexview";
import ErrorAction from "../../../../../Redux/ErrorRedux";
import PaymentPrintPreview from "../../common/paymentPrintPreview";

class TabBBMDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            bankNameOptions: [],
            bankCodeOptions: [],
            accountNameOptions: [],
            accountNumberOptions: [],
            documentOptions: [],
            categoryOption: [],
            listDataBank: [],
            jenisTransaksiOptions: [],
            selectedDoc: null,
            data: null,
            loading: false,
            searchDocVisible: false,
            alertVisible: false,
            alertMessage: null,
            alertAction: null,
            cetak: false,
            PDF: false,
            previewVisible: false,
            updatePrintCount: null
        };
    }

    componentDidMount() {
        this.fetchInitialData()
        this.fetchDataDetailCoaPayment()
    }

    fetchInitialData = async () =>{
        this.setState((prevValue) => ({ ...prevValue, loading: true }));
        const bankNameOptions = [];
        const bankCodeOptions = [];
        const accountNameOptions = [];
        const accountNumberOptions = [];
        const documentOptions = [];
        const relationOptions = [];
        const categoryOption = [];
        const listDataBank = [];
        if (this.props.isEditable || this.props.action == "editDDL" ) {
            const responses = await Promise.all([
                Api.create("NAGAMAS_MASTER_DATA").getAllMasterBank({
                    paramFilters: {
                        kodecabang: [this.props.kodeCabang],
                        status: Status.ACTIVE,
                    },
                }),
                Api.create("NAGAMAS_MASTER_DATA").getAllBizpar({
                    paramFilters: {
                        bizparCategory: "DOCUMENT_TYPE",
                        status: Status.ACTIVE,
                    },
                }),
                Api.create("NAGAMAS_MASTER_DATA").getAllBizpar({
                    paramFilters: {
                        bizparCategory: "RELATION_TYPE",
                        status: Status.ACTIVE,
                    },
                }),
                Api.create("NAGAMAS_MASTER_DATA").getAllBizpar({
                    paramFilters: {
                        bizparCategory: "PAYMENT_SPECIAL_CATEGORY",
                        status: Status.ACTIVE,
                    },
                }),
            ]);

            responses.forEach((response, idx) => {
                if (idx === 0) {
                    if (response.data.status === HttpStatus.SUCCESS) {
                        listDataBank.push(...response.data.data);
                        bankNameOptions.push(...this.getBankNameOptions(response.data.data));
                        bankCodeOptions.push(...response.data.data.map((d) => ({
                            label: d.bankCode,
                            value: d.bankCode,
                        }))
                        );
                    }
                } else if (idx === 1) {
                    if (response.data.status === HttpStatus.SUCCESS) {
                        documentOptions.push(
                            ...response.data.data.map((d) => mapToObjectDDL(d.value, d.key))
                        );
                    }
                } else if (idx === 2) {
                    if (response.data.status === HttpStatus.SUCCESS) {
                        relationOptions.push(
                            ...response.data.data.map((d) => mapToObjectDDL(d.value, d.key))
                        );
                    }
                } else {
                    if (response.data.status === HttpStatus.SUCCESS) {
                        categoryOption.push(
                            ...response.data.data.map((d) => mapToObjectDDL(d.value, d.key))
                        );
                    }
                }
            });
        }

        if (isNotNilAndEmpty(this.props.id)) {
            const response = await Api.create("NAGAMAS_TRANSACTION").getBBMDetail(this.props.id);
            if (response.data.status === HttpStatus.SUCCESS) {
                const data = response.data.data;

                const bankNameValue = data.bankId
                    ? mapToObjectDDL(`${data?.bankId.bankName} - ${data?.bankId.accountNumber}`, data?.bankId.bankName)
                    : data?.bankId;
                const bankCodeValue = data?.bankId
                    ? mapToObjectDDL(data.bankId.id, data.bankId.id)
                    : data.bankId;
                const accountNameValue = data?.bankId
                    ? mapToObjectDDL(data.bankId.accountName, data.bankId.accountName)
                    : data.bankId;
                const accountNumberValue = data?.bankId
                    ? mapToObjectDDL(data.bankId.accountNumber, data.bankId.accountNumber)
                    : data.bankId;
                const jenisRelasiValue = data.jenisRelasi
                    ? mapToObjectDDL(data.jenisRelasi.value, data.jenisRelasi.key)
                    : data.jenisRelasi;
                const dataSpecialCategoryValue = data.dataSpecialCategory
                    ? mapToObjectDDL(data.dataSpecialCategory.value, data.dataSpecialCategory.key)
                    : data.dataSpecialCategory;
                const jenisDokumenValue = data.jenisDokumen
                    ? mapToObjectDDL(data.jenisDokumen.value, data.jenisDokumen.key)
                    : data.jenisDokumen;
                const jenisTransaksi = data.dataMasterCOA
                    ? mapToObjectDDL(data.dataMasterCOA.transactionType, data.dataMasterCOA.id)
                    : data.dataMasterCOA;

                accountNameOptions.push(...listDataBank
                    .filter((d) => d.accountNumber === accountNumberValue.value)
                    .map((d) => ({
                        label: d.accountName,
                        value: d.accountName,
                    }))
                );
                accountNumberOptions.push(...listDataBank
                    .filter((d) => d.accountNumber === accountNumberValue.value)
                    .map((d) => ({
                        label: d.accountNumber,
                        value: d.accountNumber,
                    }))
                );

                this.props.setValue("bankName", bankNameValue);
                this.props.setValue("bankCode", bankCodeValue);
                this.props.setValue("namaTerimaDari", data.namaTerimaDari);
                this.props.setValue("nilaiRupiah", data.nilaiRupiah);
                if (!R.isNil(data.nilaiRupiah)) {
                    const numberWords = numberToWords(parseInt(data.nilaiRupiah));
                    const words = this.capitalizeWords(numberWords) + " Rupiah";
                    this.props.setValue("terbilang", words);
                }
                this.props.setValue("accountName", accountNameValue);
                this.props.setValue("accountNumber", accountNumberValue);
                this.props.setValue("jenisRelasi", jenisRelasiValue);
                this.props.setValue("dataSpecialCategory", dataSpecialCategoryValue);
                this.props.setValue("gunaMembayar", data.gunaMembayar);
                this.props.setValue("keterangan", data.keterangan);
                this.props.setValue("jenisTransaksi", jenisTransaksi);
                this.props.setValue("jenisDokumen", jenisDokumenValue);
                this.props.setValue("realisasi", data.realisasi);

                this.setState((prevValue) => ({
                    ...prevValue,
                    data: {
                        ...data,
                        terbilang: data.nilaiRupiah ?
                            this.capitalizeWords(numberToWords(parseInt(data.nilaiRupiah))) + " Rupiah" :
                            data.terbilang,
                        jenisRelasi: jenisRelasiValue,
                        jenisDokumen: jenisDokumenValue,
                        bankName: bankNameValue,
                        bankCode: bankCodeValue,
                        accountName: accountNameValue,
                        accountNumber: accountNumberValue,
                        dataSpecialCategory: dataSpecialCategoryValue,
                        sourcePayment: this.props.sourcePayment || data.sourcePayment || null,
                        countCetakan: data.countCetakan || 0
                    },
                    bankNameOptions,
                    bankCodeOptions,
                    accountNameOptions,
                    accountNumberOptions,
                    listDataBank,
                    documentOptions,
                    relationOptions,
                    categoryOption
                }));
            }
        } else {
            let paymentBankId = await this.fetchDataGenerateSeq({
                seqType: GenericSequenceType.PAYMENT_BANK_IN,
                nosDealerCode: this.props.kodeCabang,
                transactionType: GenericSequenceType.PAYMENT_BANK_IN,
            })

            this.setState((prevValue) => ({
                ...prevValue,
                data: {
                    ...prevValue.data,
                    paymentBankId: paymentBankId,
                    tanggalPayment: M(new Date()).format("DD-MM-YYYY"),
                    statusCetakan: "BELUM_DICETAK",
                    countCetakan: 0,
                    author: this.props.user?.user?.username,
                    sourcePayment: this.props.sourcePayment || null,
                },
                bankNameOptions,
                bankCodeOptions,
                accountNameOptions,
                accountNumberOptions,
                listDataBank,
                documentOptions,
                relationOptions,
                categoryOption
            }))
        }

        this.setState((prevValue) => ({ ...prevValue, loading: false }));
    }

    fetchDataDetailCoaPayment = async () => {
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").findDetailCoaPayment,
            menuName: "Finance - Transaksi Bank",
            setError: this.props.setError,
            args: contructQueryParam({kodeCabang: this.props.kodeCabang, category: 'TRX_IN'}),
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState((prevState) => ({
                ...prevState,
                 jenisTransaksiOptions: res.data.data.map((item) => mapToObjectDDL(item.transactionType, item.id)),
            }));
        }
    }

    getBankNameOptions = (listBank) => {
        const bankNameOptions = [];
        const uniqueBankNames = new Set();
        const newOptions = listBank
            .map((d) => ({
                label: `${d.bankName} - ${d.accountNumber}`,
                value: d.bankName,
            }))
            .filter((option) => {
                if (uniqueBankNames.has(option.value)) {
                    return false;
                }
                uniqueBankNames.add(option.value);
                return true;
            });
        bankNameOptions.push(...newOptions);
        return bankNameOptions;
    }

    handleChangeBankName = (name, value) => {
        this.props.setValue(name, value);
        this.props.setValue("accountName", null);
        this.props.setValue("accountNumber", null);
        this.props.setValue("bankCode", null);
        this.setState((prevState) => {
            let accountNameOptions = prevState.listDataBank
                .filter(item => item?.bankName === value?.value)
                .map(item => mapToObjectDDL(item.accountName, item.accountName));
            let accountNumberOptions = prevState.listDataBank
                .filter(item => item?.bankName === value?.value)
                .map(item => mapToObjectDDL(item.accountNumber, item.accountNumber));

            let bankCodeOptions;
            if (!R.isNil(value)) {
                bankCodeOptions = prevState.listDataBank
                    .filter(item => item.bankName === value.value)
                    .map(item => mapToObjectDDL(item.bankCode, item.bankCode));
            } else {
                bankCodeOptions = prevState.listDataBank
                    .map(item => mapToObjectDDL(item.bankCode, item.bankCode));
            }

            return {
                ...prevState,
                accountNameOptions: accountNameOptions,
                accountNumberOptions: accountNumberOptions,
                bankNameOptions: this.getBankNameOptions(prevState.listDataBank),
                bankCodeOptions: bankCodeOptions,
            };
        })
    }

    handleChangeBankCode = (name, value) => {
        this.props.setValue(name, value);
        this.props.setValue("accountName", null);
        this.props.setValue("accountNumber", null);

        if (!R.isNil(value)) {
            const matchedItems = this.state.listDataBank.filter(
                (item) => item.bankCode === value.value
            );

            if (matchedItems.length > 0) {
                const bank = matchedItems[0]; 
                const selectedBank = mapToObjectDDL(bank.bankName, bank.bankName);
                const selectedAccountName = mapToObjectDDL(bank.accountName, bank.accountName);
                const selectedAccountNumber = mapToObjectDDL(bank.accountNumber, bank.accountNumber);

                
                this.props.setValue("bankName", selectedBank);
                this.props.setValue("accountName", selectedAccountName);
                this.props.setValue("accountNumber", selectedAccountNumber);

                
                this.setState((prevState) => ({
                    ...prevState,
                    accountNameOptions: [selectedAccountName],
                    accountNumberOptions: [selectedAccountNumber],
                    bankNameOptions: this.getBankNameOptions(prevState.listDataBank),
                }));
            }
        }
    };

    handleSave = async () => {
        this.setState((prevValue) => ({ ...prevValue, loading: true }));
        const data = this.state.data;
        const formGroup = flattenFormGroupObject(this.props.controls);
        console.log("formGroup", formGroup);
        const request = {
            kodeCabang: this.props.kodeCabang,
            paymentId: this.props.id || data?.paymentId,
            tanggalPayment: data?.tanggalPayment,
            documentRef1Date: data?.tanggalDocumentRef1,
            documentRef1: data?.documentRef1,
            documentRef2Date: data?.tanggalDocumentRef2,
            paymentRealizationDate: formGroup?.realisasi ? dayjs(new Date()).format("DD-MM-YYYY") : null,
            documentRef2: data?.documentRef2,
            bankId: getValueFromDDL(formGroup, "bankCode"),
            transactionPersonName: formGroup?.namaTerimaDari,
            paymentRelationType: getValueFromDDL(formGroup, "jenisRelasi"),
            specialCategory: getValueFromDDL(formGroup, "dataSpecialCategory") || null,
            paymentAmount: formGroup?.nilaiRupiah ? (parseInt(formGroup?.nilaiRupiah) ?? 0) : 0,
            paymentSpellingAmount: formGroup?.terbilang,
            paymentPurpose: formGroup?.gunaMembayar,
            note: formGroup?.keterangan,
            transactionType: getValueFromDDL(formGroup, "jenisTransaksi"),
            printCount: parseInt(data?.countCetakan) ?? 0,
            paymentStatus: formGroup?.realisasi ? 'REALISASI' : this.props.paymentStatus,
            paymentType: "IN", // ??
            printStatus: data?.statusCetakan,
            documentType: getValueFromDDL(formGroup, "jenisDokumen"),
            author: data?.author,
            sourcePayment: data?.sourcePayment
        };

        console.log("request body: ", request);

        await Api.create("NAGAMAS_TRANSACTION").submitPaymentBank(request);
        this.setState((prevValue) => ({ ...prevValue, loading: false }));
        this.props.onClickClose(null);
    };

    handlePreview = async (action) => {
        if (R.equals(action, "generate")) {
            const data = this.state.data;
            const request = {
                kodeCabang: this.props.kodeCabang,
                tanggalPayment: dayjs(new Date()).format("DD-MM-YYYY"),
                paymentBankId: data?.paymentBankId,
                tanggalDocumentRef2: data?.tanggalDocumentRef2,
                documentRef2: data?.documentRef2,
                tanggalDocumentRef1: data?.tanggalDocumentRef1,
                documentRef1: data?.documentRef1,
                terbilang: data?.terbilang,
                namaTerimaDari: data?.namaTerimaDari,
                gunaMembayar: data?.gunaMembayar,
                keterangan: data?.keterangan,
                nilaiRupiah: parseInt(data?.nilaiRupiah) ?? 0,
                countCetakan: parseInt(data?.countCetakan) ?? 0,
                bankName: data?.bankId?.bankName ? data?.bankId?.bankName : data?.bankName?.value,
                accountName: data?.bankId?.accountName ? data?.bankId?.accountName : data?.accountName?.value,
                accountNumber: data?.bankId?.accountNumber ? data?.bankId?.accountNumber : data?.accountNumber?.value,
            };

            if (this.props.isEditable || this.props.action == "editDDL") {
                const controls = flattenFormGroupObject(this.props.controls);
                request.nilaiRupiah = parseInt(controls?.nilaiRupiah) ?? 0;
                request.terbilang = controls?.terbilang;
                request.gunaMembayar = controls?.gunaMembayar;
                request.keterangan = controls?.keterangan;
                request.namaTerimaDari = controls?.namaTerimaDari;
                request.accountName = controls?.accountName?.label || controls?.accountName?.value?.label || "";
                request.accountNumber = controls?.accountNumber?.label || controls?.accountNumber?.value?.label || "";
                request.bankName = controls?.bankName?.label || "";
            }

            this.setState((prevValue) => ({ ...prevValue, loading: true }));
            const response = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_REPORT").printBBM,
                setError: this.props.setError,
                menuName: "Transaksi Bank - BBM",
                args: request,
            });
            if (response.ok) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    PDF: URL.createObjectURL(response.data),
                    previewVisible: !prevValue.previewVisible,
                    updatePrintCount: null
                }));
            }
            this.setState((prevValue) => ({ ...prevValue, loading: false }));
        }

        if (R.equals(action, "close")) {
            this.setState((prevValue) => ({
                ...prevValue,
                previewVisible: !prevValue.previewVisible,
                updatePrintCount: null
            }));
        }
    };

    updatePrintCountProcess = async(id) =>{
        await fetchDataAsync({
          asyncFn: Api.create("NAGAMAS_TRANSACTION").updatePrintCountAndStatusBank,
          setError: this.props.setError,
          menuName: "Transaksi Bank - BBM",
          args: contructQueryParam({ paymentId: id }),
        });
        this.fetchInitialData();
    }

    handleCreateApprovalPrint = async () =>{
        const userId = localStorage.getItem("userId");

        this.setState({ loading: true })

        const payload = {
          trxId: this.state.data?.paymentBankId,
          kodeCabang: this.props.kodeCabang,
          idUserPemohon: userId,
          module: "TRANSAKSI_BANK",
          listBarcode: null
        };

        const res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_TRANSACTION").createApprovalPrint,
            menuName: "Transaksi Bank - BBM",
            setError: this.props.setError,
            args: payload,
        })
        this.setState({ loading: false })
        if(res.ok && res.data.status === HttpStatus.SUCCESS){
            this.handleAlertVisibility()
            this.props.onClickClose(null);
        }
    }

    handleCheckPrint = async () => {
        this.setState({ loading: true });
        const userId = localStorage.getItem("userId");
        
        const res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_TRANSACTION").checkApprovalPrintTransaction,
            menuName: "Transaksi BANK - BBM",
            setError: this.props.setError,
            args: {
              trxId: this.state.data?.paymentBankId,
              kodeCabang: this.props.kodeCabang,
              idUserPemohon: userId,
              module: "TRANSAKSI_BANK",
              listBarcode: null
            }
        })

        this.setState({ loading: false });
        if(res.ok && res.data.status === HttpStatus.SUCCESS){
            const { trxIdToPrint, idRequest } = res.data.data;
            if(trxIdToPrint && !idRequest){
                this.handlePrint()
                return
            }else if(!trxIdToPrint && !idRequest){
                this.handleConfirmPrint('approval')
                return;
            }else{
                const message = `Pengajuan tidak dapat dilakukan sebelum pengajuan dengan No. Request: ${this.state.data?.paymentBankId} \ndilakukan keputusan APPROVE/REJECT`
                this.handleAlertVisibility(message, 'in-approval');
            }
        }
    }

    handlePrint = async () => {
        const data = this.state.data;
        const request = {
            kodeCabang: this.props.kodeCabang,
            tanggalPayment: dayjs(new Date()).format("DD-MM-YYYY"),
            paymentBankId: data?.paymentBankId,
            tanggalDocumentRef2: data?.tanggalDocumentRef2,
            documentRef2: data?.documentRef2,
            tanggalDocumentRef1: data?.tanggalDocumentRef1,
            documentRef1: data?.documentRef1,
            terbilang: data?.terbilang,
            namaTerimaDari: data?.namaTerimaDari,
            gunaMembayar: data?.gunaMembayar,
            keterangan: data?.keterangan,
            nilaiRupiah: parseInt(data?.nilaiRupiah) || 0,
            countCetakan: parseInt(data?.countCetakan) || 0,
            bankName: data?.bankId?.bankName ? data?.bankId?.bankName : data?.bankName?.value,
            accountName: data?.bankId?.accountName ? data?.bankId?.accountName : data?.accountName?.value,
            accountNumber: data?.bankId?.accountNumber ? data?.bankId?.accountNumber : data?.accountNumber?.value,
        };

        if (this.props.isEditable || this.props.action == "editDDL") {
            const controls = flattenFormGroupObject(this.props.controls);
            request.nilaiRupiah = parseInt(controls?.nilaiRupiah) ?? 0;
            request.terbilang = controls?.terbilang;
            request.gunaMembayar = controls?.gunaMembayar;
            request.keterangan = controls?.keterangan;
            request.namaTerimaDari = controls?.namaTerimaDari;
            request.accountName = controls?.accountName?.label || controls?.accountName?.value?.label || "";
            request.accountNumber = controls?.accountNumber?.label || controls?.accountNumber?.value?.label || "";
            request.bankName = controls?.bankName?.label || "";
        }

        this.setState((prevValue) => ({ ...prevValue, loading: true }));
        const response = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_REPORT").printBBM,
            setError: this.props.setError,
            menuName: "Transaksi Bank - BBM",
            args: request,
        });
        if (response.ok) {
            printPDF(response.data)
            this.updatePrintCountProcess(data?.paymentId)
        }
        this.setState((prevValue) => ({ ...prevValue, loading: false, alertVisible: false, cetak: true }));
    };

    capitalizeWords = (str) => str.replace(/\b\w/g, char => char.toUpperCase());

    handleSearchDocVisibility = (value) => {
        this.setState((prevState) => ({
            ...prevState,
            selectedDoc: value,
            searchDocVisible: !prevState.searchDocVisible
        }))
    }

    handleClearDoc = (value) => {
        this.setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                documentRef1: R.equals(value, "documentRef1") ? "" : prevState.data.documentRef1,
                tanggalDocumentRef1: R.equals(value, "documentRef1") ? null : prevState.data.tanggalDocumentRef1,
                documentRef2: R.equals(value, "documentRef2") ? "" : prevState.data.documentRef2,
                tanggalDocumentRef2: R.equals(value, "documentRef2") ? null : prevState.data.tanggalDocumentRef2
            }
        }));
    }

    handleSelectDocumentReference = (data, sourceDocument) => {
        const { selectedDoc } = this.state;
        this.setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                documentRef1: R.equals(selectedDoc, "documentRef1") ? data[`nomor${sourceDocument}`] : prevState.data.documentRef1,
                tanggalDocumentRef1: R.equals(selectedDoc, "documentRef1") ? data[`tanggal${sourceDocument}`] : prevState.data.tanggalDocumentRef1,
                documentRef2: R.equals(selectedDoc, "documentRef2") ? data[`nomor${sourceDocument}`] : prevState.data.documentRef2,
                tanggalDocumentRef2: R.equals(selectedDoc, "documentRef2") ? data[`tanggal${sourceDocument}`] : prevState.data.tanggalDocumentRef2
            }
        }))

        this.handleSearchDocVisibility();
    }

    settingDisableAccount = () => {
        if (this.props.isEditable) {
            const { bankName, bankCode } = this.props.controls;
            return !!(R.isNil(bankName.value) || R.isNil(bankCode.value));
        }
        return !this.props.isEditable;
    }

    fetchDataGenerateSeq = async (body) => {
        try {
            let res = await Api.create("NAGAMAS_MASTER_DATA").generateSeqWithoutSave(body);
            if (res.ok) {
                return res.data;
            }
        } catch (error) {
            console.log("errors: ", error);
        }
    }

    handleAlertVisibility = (text, action) => {
        this.setState((prevState) => ({
            ...prevState,
            alertVisible: !prevState.alertVisible,
            alertMessage: text,
            alertAction: action
        }))
    }

    handleConfirmSave = (action) => {
        if (!this.props.validate()) {
            return;
        }

        let message = `Perubahan data BBM dengan \n no BBM: ${this.state.data?.paymentBankId} 
            \n akan dilakukan. Apakah anda yakin?`;
        this.handleAlertVisibility(message, action);
    }

    handleConfirmPrint = (action) => {
        let message = `Cetak ulang BBM dengan \n no BBM: ${this.state.data?.paymentBankId} 
            \n membutuhkan approval. Apakah anda yakin?`;
        this.handleAlertVisibility(message, action);
    }

    handleConfirmCancel = (action) => {
        let message = `Pembatalan BBM dengan \n no BBM: ${this.state.data?.paymentBankId} 
            \n akan dilakukan. Apakah anda yakin?`;
        this.handleAlertVisibility(message, action);
    }

    handleCancel = async () => {
        this.setState((prevValue) => ({ ...prevValue, loading: !prevValue.loading }));
        const request = contructQueryParam({ paymentBankId: this.state.data?.paymentBankId });
        await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_TRANSACTION").cancelPaymentBank,
            setError: this.props.setError,
            menuName: "Transaksi Bank - BBM",
            args: request,
        });
        this.setState((prevValue) => ({ ...prevValue, loading: !prevValue.loading }));
        this.props.onClickClose(null);
    }

    render() {
        return (
            <>
                <SimpleModal
                    title={this.props.title}
                    visible={this.props.visible}
                    onClickClose={() => this.props.onClickClose(this.state.cetak ? null : "")}
                    content={
                        <ModalContainer>
                            <div id="form-1" className="grid grid-3x grid-mobile-none gap-15px">
                                <div id="grid-1">
                                    <SimpleDate
                                        id="select_date_tanggal_bbm"
                                        name="tanggalPayment"
                                        label="Tanggal BBM"
                                        disabled
                                        date={new Date()}
                                    />
                                    <SimpleInput
                                        id="input_text_no_bbm"
                                        name="paymentBankId"
                                        label="No. BBM"
                                        value={this.state.data?.paymentBankId}
                                        readOnly
                                    />
                                </div>
                                <div id="grid-2">
                                    <SimpleDate
                                        id="select_date_tanggal_doc_ref1"
                                        name="tanggalDocumentRef1"
                                        label="Tanggal Dokumen Ref 1"
                                        date={this.state.data?.tanggalDocumentRef1}
                                        disabled
                                    />
                                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                        <SimpleInput
                                            id="input_text_no_doc_ref1"
                                            name="documentRef1"
                                            label="No. Dokumen Ref 1"
                                            value={this.state.data?.documentRef1}
                                            readOnly
                                        />
                                        <SimpleButton
                                            disabled={!this.props.isEditable}
                                            category="action_button"
                                            icon={<i className="fa fa-search" style={{ fontSize: 20 }} />}
                                            onClick={() => this.handleSearchDocVisibility("documentRef1")}
                                        />
                                        <SimpleButton
                                            disabled={!this.props.isEditable}
                                            category="action_button"
                                            icon={<span style={{ fontSize: "16px", fontWeight: "bold" }}>X</span>}
                                            onClick={() => this.handleClearDoc("documentRef1")}
                                        />
                                    </div>
                                </div>
                                <div id="grid-3">
                                    <SimpleDate
                                        id="select_date_tanggal_doc_ref2"
                                        name="tanggalDocumentRef2"
                                        label="Tanggal Dokumen Ref 2"
                                        date={this.state.data?.tanggalDocumentRef2}
                                        disabled
                                    />
                                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                        <SimpleInput
                                            id="input_text_no_doc_ref2"
                                            name="documentRef2"
                                            label="No. Dokumen Ref 2"
                                            value={this.state.data?.documentRef2}
                                            readOnly
                                        />
                                        <SimpleButton
                                            disabled={!this.props.isEditable}
                                            category="action_button"
                                            icon={<i className="fa fa-search" style={{ fontSize: 20 }} />}
                                            onClick={() => this.handleSearchDocVisibility("documentRef2")}
                                        />
                                        <SimpleButton
                                            disabled={!this.props.isEditable}
                                            category="action_button"
                                            icon={<span style={{ fontSize: "16px", fontWeight: "bold" }}>X</span>}
                                            onClick={() => this.handleClearDoc("documentRef2")}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="spacer" />
                            <div id="form-2">
                                <div className="grid grid-2x grid-mobile-none gap-15px">
                                    <div id="grid-1">
                                        <SimpleDDL
                                            id="select_options_nama_bank"
                                            name="bankName"
                                            label="Nama Bank"
                                            box="search"
                                            isClearable={true}
                                            options={this.state.bankNameOptions}
                                            readOnly={!this.props.isEditable}
                                            mandatory={this.props.isEditable}
                                            errorMessage={this.props.errors.bankName}
                                            value={
                                                this.props.isEditable
                                                    ? this.props.controls.bankName.value
                                                    : this.state.data?.bankName
                                            }
                                            onChange={(value, { name }) => this.handleChangeBankName(name, value)}
                                        />
                                        <SimpleDDL
                                            id="select_options_kode_bank"
                                            name="bankCode"
                                            label="Kode Bank"
                                            box="search"
                                            readOnly={!this.props.isEditable}
                                            isClearable={true}
                                            options={this.state.bankCodeOptions}
                                            value={
                                                this.props.isEditable
                                                    ? this.props.controls.bankCode.value
                                                    : this.state.data?.bankCode
                                            }
                                            onChange={(value, { name }) => this.handleChangeBankCode(name, value)}
                                        />
                                        <SimpleInput
                                            id="input_text_terima_dari"
                                            name="namaTerimaDari"
                                            label="Terima Dari"
                                            mandatory={this.props.isEditable}
                                            errorMessage={this.props.errors.namaTerimaDari}
                                            value={
                                                this.props.isEditable
                                                    ? this.props.controls.namaTerimaDari.value
                                                    : this.state.data?.namaTerimaDari
                                            }
                                            readOnly={!this.props.isEditable}
                                            onChange={({ target }) => this.props.setValue(target.name, target.value)}
                                        />
                                        <SimpleInput
                                            id="input_text_nilai_rupiah"
                                            name="nilaiRupiah"
                                            label="Nilai Rupiah"
                                            box="number"
                                            value={
                                                this.props.isEditable
                                                    ? this.props.controls.nilaiRupiah.value
                                                    : this.state.data?.nilaiRupiah
                                            }
                                            readOnly={!this.props.isEditable || this.state.data?.sourcePayment !== 'PAYMENT'}
                                            mandatory={this.props.isEditable}
                                            errorMessage={this.props.errors.nilaiRupiah}
                                            onValueChange={({ value }) => {
                                                this.props.setValue("nilaiRupiah", value);
                                                const numberWords = numberToWords(parseInt(value));
                                                const words = this.capitalizeWords(numberWords) + " Rupiah";
                                                this.props.setValue("terbilang", words);
                                            }}
                                        />
                                    </div>
                                    <div id="grid-2">
                                        <SimpleDDL
                                            id="select_options_nama_rekening"
                                            name="accountName"
                                            label="Nama Rekening"
                                            box="search"
                                            isClearable={true}
                                            options={this.state.accountNameOptions}
                                            readOnly={this.settingDisableAccount()}
                                            mandatory={this.props.isEditable}
                                            errorMessage={this.props.errors.accountName}
                                            value={
                                                this.props.isEditable
                                                    ? this.props.controls.accountName.value
                                                    : this.state.data?.accountName
                                            }
                                            onChange={(value, { name }) => {
                                                this.props.setValue(name, value)
                                                if (R.isNil(value)) {
                                                    this.props.setValue("accountNumber", null);
                                                }
                                            }}
                                        />
                                        <SimpleDDL
                                            id="select_options_nomor_rekening"
                                            name="accountNumber"
                                            label="Nomor Rekening"
                                            box="search"
                                            isClearable={true}
                                            options={this.state.accountNumberOptions}
                                            readOnly={this.settingDisableAccount()}
                                            mandatory={this.props.isEditable}
                                            errorMessage={this.props.errors.accountNumber}
                                            value={
                                                this.props.isEditable
                                                    ? this.props.controls.accountNumber.value
                                                    : this.state.data?.accountNumber
                                            }
                                            onChange={(value, { name }) => {
                                                this.props.setValue(name, value);
                                                let selectedAccountName = null;
                                                if (!R.isNil(value)) {
                                                    selectedAccountName = this.state.accountNameOptions
                                                        .find(item => item?.accountNumber === value?.accountNumber);
                                                }
                                                this.props.setValue("accountName", selectedAccountName);
                                            }}
                                        />
                                        <SimpleDDL
                                            id="select_options_jenis_relasi"
                                            name="jenisRelasi"
                                            label="Jenis Relasi"
                                            box="search"
                                            readOnly={!this.props.isEditable}
                                            options={this.state.relationOptions}
                                            mandatory={this.props.isEditable}
                                            errorMessage={this.props.errors.jenisRelasi}
                                            value={
                                                this.props.isEditable
                                                    ? this.props.controls.jenisRelasi.value
                                                    : this.state.data?.jenisRelasi
                                            }
                                            onChange={(value, { name }) => this.props.setValue(name, value)}
                                        />

                                        <SimpleDDL
                                            id="select_options_kategori_khusus"
                                            name="dataSpecialCategory"
                                            label="Kategori Khusus"
                                            box="search"
                                            // readOnly={!this.props.isEditable || this.props.paymentStatus === "REALISASI"}
                                            readOnly={(
                                              (!this.props.isEditable && this.props.action !== "editDDL") 
                                            )}
                                            options={this.state.categoryOption}
                                            errorMessage={this.props.errors.dataSpecialCategory}
                                            value={
                                                this.props.isEditable
                                                    ? this.props.controls?.dataSpecialCategory?.value
                                                    : this.state.data?.dataSpecialCategory
                                            }
                                            onChange={(value, { name }) => this.props.setValue(name, value)}
                                        />
                                    </div>
                                </div>
                                <SimpleTextArea
                                    id="input_text_terbilang"
                                    name="terbilang"
                                    label="Terbilang"
                                    value={
                                        this.props.isEditable
                                            ? this.props.controls.terbilang.value
                                            : this.state.data?.terbilang
                                    }
                                    readOnly
                                />
                                <SimpleTextArea
                                    id="input_text_guna_membayar"
                                    name="gunaMembayar"
                                    label="Guna Membayar"
                                    typeInputCase="normal"
                                    value={
                                        this.props.isEditable
                                            ? this.props.controls.gunaMembayar.value
                                            : this.state.data?.gunaMembayar
                                    }
                                    mandatory={this.props.isEditable}
                                    errorMessage={this.props.errors.gunaMembayar}
                                    readOnly={!this.props.isEditable}
                                    onChange={({ target }) => this.props.setValue(target.name, target.value)}
                                />
                                <SimpleTextArea
                                    id="input_text_keterangan"
                                    name="keterangan"
                                    label="Keterangan"
                                    typeInputCase="normal"
                                    value={
                                        this.props.isEditable
                                            ? this.props.controls.keterangan.value
                                            : this.state.data?.keterangan
                                    }
                                    mandatory={this.props.isEditable}
                                    errorMessage={this.props.errors.keterangan}
                                    readOnly={!this.props.isEditable}
                                    onChange={({ target }) => this.props.setValue(target.name, target.value)}
                                />
                            </div>
                            <div className="spacer" />
                            <div id="form-2">
                                <div className="grid grid-3x grid-mobile-none gap-15px">
                                    <div id="grid-1">
                                        <SimpleDDL
                                            id="select_options_jenis_transaksi"
                                            name="jenisTransaksi"
                                            label="Jenis Transaksi (COA)"
                                            box="search"
                                            isClearable={true}
                                            readOnly={(!this.props.isEditable && this.props.action !== "editDDL")}
                                            value={this.props.controls.jenisTransaksi.value}
                                            options={this.state.jenisTransaksiOptions}
                                            mandatory={this.props.isEditable}
                                            errorMessage={this.props.errors.jenisTransaksi}
                                            onChange={(value, { name }) => this.props.setValue(name, value)}
                                        />
                                        <SimpleInput
                                            id="input_text_count_cetakan"
                                            name="countCetakan"
                                            label="Count Cetakan"
                                            box="onlyNumber"
                                            value={this.state.data?.countCetakan}
                                            readOnly
                                        />
                                        <SimpleInput
                                            id="input_text_status_cetakan"
                                            name="statusCetakan"
                                            label="Status Cetakan"
                                            value={this.state.data?.statusCetakan}
                                            readOnly
                                        />
                                        <SimpleInput
                                            id="input_text_author"
                                            name="author"
                                            label="Author"
                                            value={this.state.data?.author}
                                            readOnly
                                        />
                                    </div>
                                    <div id="grid-2">
                                        <SimpleDDL
                                            id="select_options_jenis_dokumen"
                                            name="jenisDokumen"
                                            label="Jenis Dokumen"
                                            box="search"
                                            readOnly={!this.props.isEditable}
                                            options={this.state.documentOptions}
                                            value={this.props.isEditable ? this.props.controls.jenisDokumen.value : this.state.data?.jenisDokumen}
                                            mandatory={this.props.isEditable}
                                            errorMessage={this.props.errors.jenisDokumen}
                                            onChange={(value, { name }) => this.props.setValue(name, value)}
                                        />
                                    </div>
                                    <div id="grid-3">
                                        <SimpleCheckBox
                                            id="realisasi"
                                            name="realisasi"
                                            label="Realisasi"
                                            styles={{ marginTop: "30px" }}
                                            checked={this.props.controls.realisasi.value}
                                            disabled={this.props.action !== "realisasi" && !this.props.isEditable}
                                            onChange={({ target }) => {
                                                this.props.setValue(target.name, target.checked);
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div style={{ marginTop: "20px", display: "flex", justifyContent: "flex-end" }}>
                                {this.props.action === "batal" ? (
                                    <SimpleButton text="Batal" onClick={() => this.handleConfirmCancel("cancel")} />
                                ) : (
                                    <>
                                        {!this.props.isPreview && (
                                            <>
                                                <SimpleButton
                                                    text="Preview"
                                                    onClick={() => this.handlePreview("generate")}
                                                />
                                                <SimpleButton
                                                    text="Cetak"
                                                    onClick={() => this.handleCheckPrint("cetak")}
                                                />
                                            </>
                                        )}

                                        {(this.props.isEditable || this.props.action === "realisasi" || this.props.action === "editDDL" ) && (
                                            <SimpleButton
                                                text="Simpan"
                                                onClick={() => this.handleConfirmSave("save")}
                                            />
                                        )}
                                    </>
                                )}
                            </div>
                        </ModalContainer>
                    }
                />
                {this.state.previewVisible && (
                    <PaymentPrintPreview
                        {...this.props}
                        title="Preview Print BBM"
                        PDF={this.state.PDF}
                        orientation="potrait"
                        paper="A4"
                        updatePrintCount={this.state.updatePrintCount}
                        visible={this.state.previewVisible}
                        onClickClose={() => this.handlePreview("close")}
                    />
                )}
                {this.state.searchDocVisible && (
                    <DocumentReference
                        kodeCabang={this.props.kodeCabang}
                        onClickSelectDocumentReference={this.handleSelectDocumentReference}
                        visible={this.state.searchDocVisible}
                        onClickClose={this.handleSearchDocVisibility}
                    />
                )}
                {this.state.alertVisible && (
                    <SimpleAlert
                        visible={this.state.alertVisible}
                        text={this.state.alertAction === "in-approval" ? "Ok" : "Batal"}
                        onClickClose={this.handleAlertVisibility}
                        content={
                            <div>
                                <p>{this.state.alertMessage}</p>
                                <FlexView hAlignContent="center">
                                    <SimpleButton
                                        className="margin-top-15px"
                                        text="Batal"
                                        onClick={() => this.handleAlertVisibility()}
                                    />
                                    {this.state.alertAction === "approval" && (
                                        <SimpleButton
                                            className="margin-top-15px"
                                            text="Iya"
                                            onClick={() => this.handleCreateApprovalPrint()}
                                        />
                                    )}
                                    {this.state.alertAction === "save" && (
                                        <SimpleButton
                                            className="margin-top-15px"
                                            text="Iya"
                                            onClick={() => this.handleSave()}
                                        />
                                    )}
                                    {this.state.alertAction === "cetak" && (
                                        <SimpleButton
                                            className="margin-top-15px"
                                            text="Iya"
                                            onClick={() => this.handlePrint()}
                                        />
                                    )}
                                    {this.state.alertAction === "cancel" && (
                                        <SimpleButton
                                            className="margin-top-15px"
                                            text="Iya"
                                            onClick={() => this.handleCancel()}
                                        />
                                    )}
                                </FlexView>
                            </div>
                        }
                    />
                )}
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading} />}
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.auth,
    };
};


const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withFormGroup(TabBBMDetail));
